export const ACTION_GET_LIST_PRODUCTS = '/CompareProduct/GetListProducts';

export const ACTION_GET_PRODUCT_INFO = '/CompareProduct/GetProduct';
